.pagination {
	margin-left: auto;
	display: grid;
	grid-template: "back info forward" auto / auto auto auto;
	align-items: center;
	gap: var(--size-3);
}

.info {
	grid-area: info;
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}
